import { FC } from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from 'recharts';
import { useThemeValue } from '@altermaind/web/ui';

type Props = {
  data: { key: string; value: number }[];
  domainHasInPercentage?: boolean;
};

export const PercentageLineChart: FC<Props> = ({ data, domainHasInPercentage }) => {
  const primaryColor = useThemeValue('colors', 'primary');

  return (
    <ResponsiveContainer width='100%' height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray='3 3' stroke='#444' vertical={false} />
        <XAxis dataKey='key' stroke='#ccc' tickLine={false} axisLine={false} />
        <YAxis
          stroke='#ccc'
          tickFormatter={val => (domainHasInPercentage ? `${val}%` : `${val}`)}
          axisLine={false}
          tickLine={false}
        />
        <Tooltip
          formatter={value => {
            return [`${value}`];
          }}
          contentStyle={{
            backgroundColor: '#fff',
            color: '#000',
            borderRadius: '8px',
            padding: '6px 10px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
            fontSize: '14px',
            border: 'none',
          }}
        />{' '}
        <Line type='monotone' dataKey='value' stroke={primaryColor} strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
};
